import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=4388d6a1"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&id=4388d6a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports